"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentHeader = void 0;
// (C) 2021 GoodData Corporation
var DocumentHeader_1 = require("./DocumentHeader");
Object.defineProperty(exports, "DocumentHeader", { enumerable: true, get: function () { return __importDefault(DocumentHeader_1).default; } });
//# sourceMappingURL=index.js.map